import GeneralForm from "components/GeneralForm";
import { validate } from "components/validateGeneralForm";
import { useState } from "react";
import { Button, Card, CardBody } from "reactstrap";

export default function FormPreposto({ onAdd }) {
  const [data, setData] = useState({})

  const formConfig = [
    [
      { name: "nome", label: 'Nome', type: "text", required: true, colspan: 12 },
      { name: "email", label: 'E-mail', type: "text", required: true, colspan: 8 },
      { name: "telefone", label: 'Telefone', type: "phone", required: true, colspan: 4 },
    ],
  ]

  const handleChange = (field, value) => {
    setData({ ...data, [field]: value })
  }


  const handleSubmit = e => {
    e.preventDefault()

    const errors = validate(formConfig, data)
    if (errors.length > 0) {
      setData({ ...data, errors })
      // erros foram encontrados
      return
    }
    onAdd && onAdd(data)
    setData({})
  }

  return (
    <Card>
      <CardBody>
        <h2>Adicionar Prepostos</h2>
        <form onSubmit={handleSubmit}>
          <GeneralForm
            config={formConfig}
            data={data}
            onChange={handleChange}
          />
          <div className="text-right">
            <Button type="submit" color="primary">Salvar</Button>
          </div>
        </form>
      </CardBody>
    </Card>
  )
}